export default __webpack_public_path__ + "static/media/3.fcdc62b8.png";